<template>
    <div>
        <header class="bg-main-gradient">
            <div class="container" style="padding: 140px 0 0 0">
                <div class="row">
                    <div class="col-xl-7 text-center">
                        <h1 class="font-weight-bold text-white display-4 px-2">
                            Program Ishrane
                        </h1>
                        <h2 class="font-weight-bold text-light px-2">
                            Profesionalni softver za nutricioniste
                        </h2>
                        <div class="py-3">
                            <a href="https://www.programprehrane.com/registracija?lang=sr"
                                class="btn btn-light m-2 pt-2 main-border bg-white" style="width:260px;height:50px;"
                                title="Registracija">
                                <icon name="user-plus" scale=2 class="text-main" />
                                <span class="lead font-weight-bold text-main pl-1">Postani korisnik</span>
                            </a>
                            <a href="https://www.programprehrane.com/app/#/?lang=sr" class="btn btn-outline-light m-2 main-border"
                                style="width:260px;height:50px;" title="Prijava u aplikaciju">
                                <icon name="sign-in-alt" scale=2 class="text-white" />
                                <span class="lead font-weight-bold text-white pl-1">Ulaz za korisnike</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-5">
                        <img src="../assets/img/ppweb_mockup.png" alt="ppweb_mockup.png"
                            class="img-fluid d-none d-md-block" />
                    </div>
                </div>
            </div>
        </header>
        <div class="container-fluid text-center px-0 pt-2">
            <section class="container py-5">
                <h2 class="text-center font-weight-bold mb-4">Glavne karakteristike aplikacije</h2>
                <hr class="w-25 mx-auto mb-4">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="users" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Klijenti</h3>
                        <p class="feature-text m-2">Evidencija klijenata, praćenje antropometrijskih parametara, metabolički
                            Proračuni i analiza sastava tela.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="heartbeat" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Normativi</h3>
                        <p class="feature-text m-2">Smernice za sve uzraste i različite vrste dijeta. Normativi za kreiranje
                            jelovnika u vrtićima i osnovnim školama.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="utensils" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Plan ishrane</h3>
                        <p class="feature-text m-2">Kreiranje dnevnih jelovnika i nedeljnog plana ishrane za pojedince i
                            grupe. Analiza makro- i mikronutrijenata.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="file" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Nutricionistički izveštaji</h3>
                        <p class="feature-text m-2">Izrada nutricionističkih izveštaja na osnovu podataka iz dnevnika
                            ishrane i antropometrijskih parametara.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="mobile" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Aplikacija za klijente</h3>
                        <p class="feature-text m-2">Veb aplikacija preko koje klijenti vode dnevnik ishrane, preuzimaju
                            jelovnike i izveštaje i prate svoj napredak.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 p-3">
                        <icon name="brain" scale=2 class="text-main" />
                        <h3 class="lead mb-0 mt-2 font-weight-bold">Veštačka inteligencija</h3>
                        <p class="feature-text m-2">Integrisana AI podrška za kreiranje recepata i slika jela,
                            nutricionističkih izveštaja, prevoda jelovnika i drugo.</p>
                    </div>
                </div>
            </section>

            <section class="py-5 px-2 bg-light">
                <div class="container">
                    <div class="text-center mb-5">
                        <h2 class="font-weight-bold">Zašto izabrati Program Ishrane?</h2>
                        <hr class="w-50 mx-auto mb-4">
                        <p class="text-muted mt-3">
                            <strong>Program Ishrane</strong> je proveren i pouzdan softver koji već {{yearsOfDevelopment}} godina koriste
                            nutricionisti, zdravstvene ustanove i obrazovne institucije. Zahvaljujući jednostavnom
                            interfejsu,
                            pristupačnoj ceni i fleksibilnim modelima pretplate, softver je dostupan i osobama bez
                            stručnog znanja koje vode računa o zdravoj i uravnoteženoj ishrani.
                        </p>
                    </div>
                    <div class="row text-center">
                        <div class="col-md-4 mb-4">
                            <icon name="check-circle" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">{{yearsOfDevelopment}} godina razvoja</h5>
                            <p class="feature-text">Stabilan i razvijan u saradnji sa profesionalcima iz prakse.</p>
                        </div>
                        <div class="col-md-4 mb-4">
                            <icon name="user-md" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">Koristi se u zdravstvu</h5>
                            <p class="feature-text">Naš sistem svakodnevno koriste poliklinike, zavodi i privatni
                                nutricionisti – već dugi niz godina.</p>
                        </div>
                        <div class="col-md-4 mb-4">
                            <icon name="brain" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">Veštačka inteligencija</h5>
                            <p class="feature-text">Automatizacija kreiranja recepata, nutricionističkih izveštaja i slika
                                jela uz AI podršku.</p>
                        </div>
                        <div class="col-md-4 mb-4">
                            <icon name="thumbs-up" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">Jednostavan za korišćenje</h5>
                            <p class="feature-text">Intuitivan interfejs prilagođen i stručnjacima i korisnicima bez
                                stručnog znanja.</p>
                        </div>
                        <div class="col-md-4 mb-4">
                            <icon name="shield-alt" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">Bezbednost podataka</h5>
                            <p class="feature-text">Zaštita i privatnost podataka su naš prioritet.</p>
                        </div>
                        <div class="col-md-4 mb-4">
                            <icon name="sync-alt" scale=3 class="text-main mb-3" />
                            <h5 class="font-weight-bold">Stalne nadogradnje</h5>
                            <p class="feature-text">Redovno uvodimo nove funkcionalnosti prema željama korisnika.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="py-5">
                <div class="container">
                    <div class="row text-center">
                        <div class="col-md-4 mb-4">
                            <div class="circle-stat mb-3">+800</div>
                            <h5 class="text-main font-weight-bold">Aktivnih korisnika</h5>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="circle-stat mb-3">+160 000</div>
                            <h5 class="text-main font-weight-bold">Kreiranih jelovnika</h5>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="circle-stat mb-3">+20 000</div>
                            <h5 class="text-main font-weight-bold">Klijenata</h5>
                        </div>
                    </div>
                </div>
            </section>

            <section id="awards" class="py-5">
                <div class="container text-center">
                    <h2 class="font-weight-bold mb-3">Priznanja</h2>
                    <hr class="w-25 mx-auto mb-4">
                    <div class="row mt-4">
                        <div class="col-md-3 mb-4">
                            <div class="flip-box card p-2" style="cursor:move">
                                <div class="flip-box-inner">
                                    <div class="flip-box-front">
                                        <img src="../assets/img/awards/inova34.jpg" alt="inova34.jpg"
                                            class="img-fluid flip-box-img" loading="lazy" />
                                    </div>
                                    <div class="flip-box-back">
                                        <h3 class="font-weight-bold"> INOVA 34</h3>
                                        <div ng-if="longdesc">Zlatna medalja na 34. hrvatskom salonu inovacija INOVA 2009
                                            (Verzija 1.0 iz 2008 g.)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="flip-box card p-2" style="cursor:move">
                                <div class="flip-box-inner">
                                    <div class="flip-box-front">
                                        <img src="../assets/img/awards/inova37.jpg" alt="inova37.jpg"
                                            class="img-fluid flip-box-img" loading="lazy" />
                                    </div>
                                    <div class="flip-box-back">
                                        <h3 class="font-weight-bold"> INOVA 37</h3>
                                        <div ng-if="longdesc">Zlatna medalja na 37. salonu inovacija INOVA 2012, sa
                                            međunarodnim sudjelovanjem (Verzija 2.0 iz 2012 g)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="flip-box card p-2" style="cursor:move">
                                <div class="flip-box-inner">
                                    <div class="flip-box-front">
                                        <img src="../assets/img/awards/inventum2013.jpg" alt="inventum2013.jpg"
                                            class="img-fluid flip-box-img" loading="lazy" />
                                    </div>
                                    <div class="flip-box-back">
                                        <h3 class="font-weight-bold"> INVENTUM 2013</h3>
                                        <div ng-if="longdesc">Srebrna medalja na sajmu INVENTUM 2013 g. (Verzija 3.0 iz 2012
                                            g)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4">
                            <div class="flip-box card p-2" style="cursor:move">
                                <div class="flip-box-inner">
                                    <div class="flip-box-front">
                                        <img src="../assets/img/awards/agroarca.png" alt="agroarca.png"
                                            class="img-fluid flip-box-img" loading="lazy" />
                                    </div>
                                    <div class="flip-box-back">
                                        <h3 class="font-weight-bold"> Agro Arca</h3>
                                        <div ng-if="longdesc">Plaketa na sajmu Agro Arca 2013. godine (Verzija 4.0 iz 2013
                                            g)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mt-4 text-center">
                    <p class="text-muted">
                        <strong>* Program Prehrane</strong> uvršten je na listu 50 najperspektivnijih hrvatskih poslovnih programskih rješenja za 2020. godinu!
                    </p>
                </div> -->
                </div>
            </section>

            <section class="py-5 bg-main-gradient text-white text-center">
                <div class="container">
                    <h2 class="font-weight-bold text-light mb-3">Započni odmah sa Programom Ishrane</h2>
                    <p class="lead mb-4">
                        Pridruži se stotinama zadovoljnih korisnika širom regiona i isprobaj besplatno! Uveri se zašto nas
                        nutricionisti, poliklinike i obrazovne ustanove biraju već {{yearsOfDevelopment}} godina.
                    </p>
                    <a href="https://www.programprehrane.com/registracija?lang=sr"
                        class="btn btn-light m-2 main-border bg-white d-inline-flex align-items-center justify-content-center"
                        style="width:260px;" title="Postani korisnik">
                        <icon name="user-plus" scale=2 class="text-main mr-2" />
                        <span class="lead text-main font-weight-bold mb-0">Registruj se</span>
                    </a>
                </div>
            </section>

            <section class="py-5">
                <div class="container">
                    <h2 class="text-center font-weight-bold mb-3">Naši korisnici</h2>
                    <hr class="w-25 mx-auto mb-4">
                    <div class="row align-items-center">
                        <div class="col-lg-6 mb-4">
                            <p class="text-justify">
                                Od svog početka <strong>2008. godine</strong> pa do danas, računarski program i veb
                                aplikacija
                                <strong>Program Ishrane</strong> prepoznati su kao praktičan i pouzdan alat za analizu
                                prehrambenih navika
                                i izradu individualizovanih planova ishrane. Koriste ih brojni nutricionisti, pojedinci i
                                sportisti širom regiona koji vode računa o zdravoj i uravnoteženoj ishrani.
                            </p>
                            <div class="text-left">
                                <p class="mt-3"><strong>Program Ishrane</strong> koriste i preporučuju:</p>
                                <ul class="pl-3">
                                    <li>Poliklinike i bolnice</li>
                                    <li>Zavodi za javno zdravlje</li>
                                    <li>Specijalističke ordinacije i apoteke</li>
                                    <li>Obrazovne ustanove, učenički domovi i domovi za stare</li>
                                    <li>Sportski klubovi i profesionalni treneri</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 text-center">
                            <img src="../assets/img/program_prehrane_web_korisnici.png?v=28.01.2026"
                                alt="Korisnici Programa Ishrane" class="img-fluid img-thumbnail shadow-sm" loading="lazy">
                        </div>
                    </div>
                    <div class="mt-5">
                        <div class="text-center">
                            <div class="row mt-3" data-nosnippet>
                                <div v-for="x in customers" class="col-2 pt-3">
                                    <img :src="require(`@/assets/img/customers/${x.img}`)" class="img-fluid customers-img"
                                        alt="" :title="x.title" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>

        <section class="pt-5">
            <div class="container">
                <div class="text-center">
                    <h2>PAKETI</h2>
                    <hr class="w-25 mx-auto mb-4" />
                    <p class="text-muted mx-auto mb-4" style="max-width: 600px;">
                        Cena paketa počinje od <strong>5 € mesečno</strong> (uz pretplatu na 3 godine).<br>
                        Cene variraju u zavisnosti od plana pretplate, izabranog paketa i broja licenci.<br><br>
                        <span class="text-main fw-semibold">Popusti:</span><br>
                        ✔️ 20% popusta za pretplatu na 2 godine<br>
                        ✔️ 30% popusta za pretplatu na 3 godine
                    </p>

                <p v-if="prices.discount.perc>0" class="text-main font-weight-bold">
                    Na godišnju, dvogodišnju i trogodišnju pretplatu obračunava se dodatni popust od {{prices.discount.perc}}%. Akcija važi do {{prices.discount.validTo}}.
                </p>

                </div>
                <div class="row slideanim">
                    <!-- <div class="col-xl-3 col-lg-6 col-md-12 p-2">
                        <div class="card text-center">
                            <div class="card-header main-gradient">
                                <h3 class="font-weight-bold">DEMO</h3>
                            </div>
                            <div class="card-body pt-2">
                                <div class="p-2 pb-4">
                                    <span class="text-nowrap"><label class="lead font-weight-bold">{{
                                        convertAndFormat(prices.demo.min_mo_price) }}</label></span>
                                    <hr class="m-0" />
                                </div>
                                <div>
                                    <div><s class="text-muted">Dodatne licence</s></div>
                                    <div>Br. klijenata: <strong>1</strong></div>
                                    <div>Br. namirnica: <strong>664</strong></div>
                                    <div>Br. fizičkih aktivnosti: <strong>470</strong></div>
                                    <div>Maks. broj obroka: <strong>6</strong></div>
                                    <div>Metode proračuna BMR: <strong>1</strong></div>
                                    <div><s class="text-muted">Kalendar termina</s></div>
                                    <div><s class="text-muted">Aplikacija za klijente</s></div>
                                    <div><s class="text-muted">Pristup USDA bazi namirnica</s></div>
                                    <div><s class="text-muted">AI podrška</s></div>
                                    <div>
                                        <router-link to="paketi" title="paketi">
                                            <span>više...</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="p-1">
                                    <a href="https://www.programprehrane.com/registracija?lang=sr"
                                        class="text-main font-weight-bold lead" title="Registracija">
                                        <icon name="sign-in-alt" scale=1 /> Registracija
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-xl-4 col-lg-6 col-md-12 p-2">
                        <div class="card h-100 text-center zoom">
                            <div class="card-header bg-main-gradient">
                                <h2 class="font-weight-bold text-white">START</h2>
                            </div>
                            <div class="card-body pt-2">
                                <div class="p-2 pb-4 text-center">
                                    <span class="text-nowrap">od <label class="lead font-weight-bold">{{
                                        convertAndFormat(prices.start.min_mo_price) }}</label> mesečno</span>
                                    <hr class="m-0" />
                                </div>
                                <div>
                                    <!-- <div><s class="text-muted">Dodatne licence</s></div> -->
                                    <div>✔ Br. klijenata: <strong>5/mesečno</strong></div>
                                    <div>✔ Br. namirnica: <strong>664</strong></div>
                                    <div>✔ Br. fizičkih aktivnosti: <strong>470</strong></div>
                                    <div>✔ Maks. broj obroka: <strong>6</strong></div>
                                    <div>✔ Metode proračuna BMR: <strong>1</strong></div>
                                    <!-- <div><s class="text-muted">Kalendar termina</s></div>
                                    <div><s class="text-muted">Aplikacija za klijente</s></div>
                                    <div><s class="text-muted">Pristup USDA bazi namirnica</s></div>
                                    <div><s class="text-muted">AI podrška</s></div> -->
                                    <div class="pt-2">
                                        <router-link to="paketi" title="paketi">
                                            <span class="text-main font-weight-bold">više...</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="p-1">
                                    <a href="https://www.programprehrane.com/narudzba?lang=sr"
                                        class="text-main font-weight-bold lead" title="Porudžbina">
                                        <icon name="shopping-cart" scale=1 /> Porudžbina
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 p-2">
                        <div class="card h-100 text-center zoom">
                            <div class="card-header bg-main-gradient text-white">
                                <h2 class="font-weight-bold text-white">STANDARD</h2>
                            </div>
                            <div class="card-body pt-2">
                                <div class="p-2 pb-4">
                                    <span class="text-nowrap"></span>
                                    <span class="text-nowrap">od <label class="lead font-weight-bold">{{
                                        convertAndFormat(prices.standard.min_mo_price) }}</label> mesečno</span>
                                    <hr class="m-0" />
                                </div>
                                <div>
                                    <div>✔ Dodatne licence: <strong>maks. 1 <sup custom-popover
                                                popover-html="Odnosi se na dodatne korisnike aplikacije koji unutar jednog tima (zajedničke radne organizacije ili ustanove) imaju pravo pristupa zajedničkoj bazi podataka. Korisnici STANDARD paketa imaju pravo na registraciju jednog dodatnog korisnika. Cena dodatne licence iznosi 100,00 €/god. (obrazovne ustanove: 10,00 €/god.)."
                                                popover-placement="bottom" popover-trigger="hover"
                                                popover-label=""></sup></strong></div>
                                    <div>✔ Br. klijenata: <strong>20/mesečno</strong></div>
                                    <div>✔ Br. namirnica: <strong>740</strong></div>
                                    <div>✔ Br. fizičkih aktivnosti: <strong>470</strong></div>
                                    <div>✔ Maks. broj obroka: <strong>6</strong></div>
                                    <div>✔ Metode proračuna BMR: <strong>4</strong></div>
                                    <div>✔ Kalendar termina</div>
                                    <div>✔ Aplikacija za klijente</div>
                                    <!-- <div><s class="text-muted">Pristup USDA bazi namirnica</s></div>
                                    <div><s class="text-muted">AI podrška</s></div> -->
                                    <div class="pt-2">
                                        <router-link to="paketi" title="paketi">
                                            <span class="text-main font-weight-bold">više...</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="p-1">
                                    <a href="https://www.programprehrane.com/narudzba?lang=sr"
                                        class="text-main font-weight-bold lead" title="Porudžbina">
                                        <icon name="shopping-cart" scale=1 /> Porudžbina
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 p-2">
                        <div class="card h-100 text-center zoom shadow">
                            <div class="card-header bg-main-gradient text-white">
                                <h2 class="font-weight-bold text-white">PREMIUM</h2>
                            </div>
                            <div class="card-body pt-2">
                                <div class="p-2 pb-4">
                                    <span class="text-nowrap">od <label class="lead font-weight-bold">{{
                                        convertAndFormat(prices.premium.min_mo_price) }}</label> mesečno</span>
                                    <hr class="m-0" />
                                </div>
                                <div>
                                    <div>✔ Dodatne licence: <strong>neograničeno<sup custom-popover
                                                popover-html="Odnosi se na dodatne korisnike aplikacije koji unutar jednog tima (zajedničke radne organizacije ili ustanove) imaju pravo pristupa zajedničkoj bazi podataka. Cena dodatne licence iznosi 100,00 €/god. (obrazovne ustanove: 10,00 €/god.)."
                                                popover-placement="bottom" popover-trigger="hover"
                                                popover-label=""></sup></strong></div>
                                    <div>✔ Br. klijenata: <strong>neograničeno</strong></div>
                                    <div>✔ Br. namirnica: <strong>970</strong></div>
                                    <div>✔ Br. fizičkih aktivnosti: <strong>727</strong></div>
                                    <div>✔ Maks. broj obroka: <strong>9</strong></div>
                                    <div>✔ Metode proračuna BMR: <strong>5</strong></div>
                                    <div>✔ Kalendar termina</div>
                                    <div>✔ Aplikacija za klijente</div>
                                    <div>✔ Pristup USDA bazi namirnica</div>
                                    <div>✔ AI funkcije</div>
                                    <div class="pt-2">
                                        <router-link to="paketi" title="paketi">
                                            <span class="text-main font-weight-bold">više...</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="p-1">
                                    <a href="https://www.programprehrane.com/narudzba?lang=sr"
                                        class="text-main font-weight-bold lead" title="Porudžbina">
                                        <icon name="shopping-cart" scale=1 /> Porudžbina
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>

    </div>
</template>

<script>
import cHeader from "../components/cHeader.vue";
import { prices } from "../config/prices";
export default {
    metaInfo() {
        return {
            title: 'Program Ishrane',
            titleTemplate: '%s | ' + 'Softver za nutricioniste',
        }
    },
    data() {
        return {
            prices,
            customers: [
                { img: "mfuub.jpg", title: "Medicinski fakultet univerzitet u Beogradu" },
                { img: "ptfo.png", title: "Prehrambeno tehnoloski fakultet Osijek" },
                { img: "vup.png", title: "Veleučilište u Požegi" },
                { img: "zavod_za_javno_zdravstvo_dubrovacko_neretvanske_zupanije.png", title: "Zavod za javno zdravstvo Dubrovacko Neretvanske Županije" },
                { img: "opca_bolnica_zadar.png", title: "Opća bolnica Zadar" },
                { img: "zavod_za_javno_zdravstvo_medimurske_zupanije.jpg", title: "Zavod za javno zdravstvo Medimurske županije" },
                { img: "univerzitet_modernih_znanosti_mostar.jpg", title: "Univerzitet modernih znanosti Mostar" },
                { img: "zzjzvz.png", title: "Zavod za janov zravstvo Varaždinske županije" },
                { img: "sbzmr_varazdinske_toplice.jpg", title: "Specijalna bolnica za rehabilitaciju Varaždinske Toplice" },
                { img: "zzjzv.png", title: "Zavod za javno zdravlje Valjeno" },
                { img: "vssszovits.png", title: "Visoka škola strukovnih studija za obrazovanje vaspitača i trenera u Subotici" },
                { img: "sveucilisna_klinicka_bolnica_mostar.png", title: "Sveučilišna klinička bolnica mostar" },
                { img: "hzjz.png", title: "Hrvatski zavod za javno zdravstvo" },
                { img: "institut_za_zdravlje_i_sigurnost_hrane_zenica.jpg", title: "Institut za zdravlje i sigurnost hrane Zenica" },
                { img: "taekwondo_klub_novi_grad_sarajevo.png", title: "Taekwondo klub Novi Grad Sarajevo" },
                { img: "pb_rab.png", title: "Psihijatrijska bolnica Rab" },
                { img: "zavod_za_javno_zdravstvo_pgz.jpg", title: "Zavod za javno zdravstvo Primorsko goranske Županije" },
                { img: "zavod_za_javno_zdravlje_subotica.jpg", title: "Zavod za javno zdravlje Subotica" }
            ],
            yearsOfDevelopment : new Date().getFullYear() - 2008
        };
    },
    components: {
        cHeader,
    },
    methods: {
        convertAndFormat(value) {
            const rsd = value * prices.conversionRate;
            return new Intl.NumberFormat('sr-RS', {
                style: 'currency',
                currency: prices.currency,
                minimumFractionDigits: 2
            }).format(rsd);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/pages/home.vue